import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Agency } from './agency';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  private url = baseUrl + gatewayFile;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getAgencyList(): Observable<Agency[]> {
    const url = `${this.url}`;
    return this.http.post<Agency[]>(url, { token: localStorage.getItem('token'), function: 'getAgencyList' })
    .pipe(
      catchError(this.handleError('getAgencyList', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
